import m from 'moment';
import { CollisionType, dateFormat, timeFormat, AllWeekDays, serverDateFormat, Languages } from './constants';
import formatCurrency from 'format-currency';
import { Currencies } from './currencies';
import { TransactionCodeHardCodedType, HotelFeatureCodes } from '../../components/shared/constants';
import { TransactionCode, Taxes, Users } from '../../api/services/next';
import { extendMoment } from 'moment-range';
const moment = extendMoment(m);

export const toServerDateFormat = (date) => {
    return moment(date).format(serverDateFormat);
}

export const groupBy = (array, ...properties) => {
    return array.reduce(function (acc, obj) {
        var key = properties.map(property => obj[property]).join('-');
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}

export const groupByIntoArray = (array, ...properties) => {
    return array ? Object.values(array.reduce((acc, obj) => {
        var key = properties.map(property => obj[property]).join('-');
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {})) : [];
}

export const pickBy = (obj, fn) =>
    Object.entries(obj)
        .filter(([, value]) => fn(value)) //Filter by the given predicate
        .reduce((acc, [key, value]) => ((acc[key] = value), acc), {}); //Recreate an object from the passed array of tuples

export const arrayToObject = (array, keySelector = (e) => e.toString()) => {
    return array ? Object.fromEntries(array.map((element) => [keySelector(element), element])) : [];
}

export const GetFullName = person => {
    const fName = person && person.FirstName ? person.FirstName : '';
    const lName = person && person.LastName ? person.LastName : '';
    return (fName + " " + lName).replace(/(\r\n|\n|\r)/gm, " ");
}

export const getContrastYIQ = (hexcolor) => {
    if (hexcolor) {
        hexcolor = hexcolor.replace("#", "")
        var r = parseInt(hexcolor.substr(0, 2), 16)
        var g = parseInt(hexcolor.substr(2, 2), 16)
        var b = parseInt(hexcolor.substr(4, 2), 16)
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
        return (yiq >= 128) ? 'black' : 'white'
    } else {
        return 'black'
    }
}

export const hasDigitalCertificate = async(userId = null) => {

    try {
        if (!window.optima?.user?.CurrentHotel?.HotelFeatures?.find(
            (hf) => hf.FeatureID === HotelFeatureCodes.DigitalInvoice))
            return true; // Digital invoice feature is not enabled, so no need for a digital certificate

        var user = await Users.GetDigitalCertificateData({ userId: userId ?? window.optima.user.Id });

        if (!user || !user.DigitalCertificateToken) {
            return false;
        }

        return true;
    }
    catch (error) {
        return false;
    }
}
export const calculateAccomodationTaxes = async (reservation, amount, isAfterTax, HotelId) => {
    try { 
        const dailyRoomCharge = await TransactionCode.GetTransactionCode({
            TransactionCodeHardcodedTypeId: TransactionCodeHardCodedType.Dailyroomcharge
        })        
        const dates = getDaysOfDatesRange(reservation.CheckInDate, reservation.CheckOutDate).slice(0, -1);
        let Items = [];
        dates.forEach(date => {
            const item = {
                TransactionCodeId: dailyRoomCharge[0]?.Id ?? 0,
                AmountBeforeTax: isAfterTax ? null : amount / dates.length,
                AmountAfterTax: isAfterTax ? amount / dates.length : null,
                Date: date,
            }
            Items.push(item)
        });

        const calculatedItems = await Taxes.CalculateTaxes({
            HotelId: HotelId,
            Items: Items,
            CurrencyCode: reservation?.CurrencyId,
            Pax: reservation ? {
                Adults: reservation.Adults,
                Infants: reservation.Infants,
                Children: reservation.Children
            } : null
        })
        return calculatedItems
    }
    catch (error) {
        return error
    }
}
export const toDaysArray = (rateElement) => {
    let days = [];
    if (rateElement.ActiveSunday)
        days.push(0);
    if (rateElement.ActiveMonday)
        days.push(1);
    if (rateElement.ActiveTuesday)
        days.push(2);
    if (rateElement.ActiveWedensday)
        days.push(3);
    if (rateElement.ActiveThursday)
        days.push(4);
    if (rateElement.ActiveFriday)
        days.push(5);
    if (rateElement.ActiveSaturday)
        days.push(6);
    return days;
}

export const toBitmask = (weekdays) => {
    let fieldNames = ["ActiveSunday", "ActiveMonday", "ActiveTuesday", "ActiveWedensday", "ActiveThursday", "ActiveFriday", "ActiveSaturday"]
    let obj = {};
    for (let i = 0; i < fieldNames.length; i++) {
        obj[fieldNames[i]] = weekdays.includes(i);
    }
    return obj;
}


export const getDaysOfDatesRange = (startDate, endDate, allowedDays = [0, 1, 2, 3, 4, 5, 6]) => {
    if (!startDate ||
        !endDate ||
        moment(startDate).startOf("day").isAfter(moment(endDate).startOf("day"))) return [];
    const days = Array.from(moment.range(startDate, endDate).by("day"));
    return days.filter(date => allowedDays.includes(date.day()));
}

export const getCollisionType = (range1, range2, propName = "Weekdays") => {
    const weekdaysArrayRange1 = Array.isArray(range1[propName]) ? range1[propName] : makeIntToDaysOfWeekArray(range1[propName]);
    const weekdaysArrayRange2 = Array.isArray(range2[propName]) ? range2[propName] : makeIntToDaysOfWeekArray(range2[propName]);

    const collisionDays = weekdaysArrayRange1.filter(day => weekdaysArrayRange2.includes(day));
    if (collisionDays.length === 0) return CollisionType.NO_COLLISION; // no collision: [] ()

    const range1Start = moment(range1.StartDate).startOf('day').set({
        'hour': range1.StartTime ? moment(range1.StartTime, 'HH:mm:ss').hours() : 0,
        'minute': range1.StartTime ? moment(range1.StartTime, 'HH:mm:ss').minutes() : 0,
    });

    const range1End = moment(range1.EndDate).endOf('day').set({
        'hour': range1.EndTime ? moment(range1.EndTime, 'HH:mm:ss').hours() : 23,
        'minute': range1.EndTime ? moment(range1.EndTime, 'HH:mm:ss').minutes() : 59,
    });

    const range2Start = moment(range2.StartDate).startOf('day').set({
        'hour': range2.StartTime ? moment(range2.StartTime, 'HH:mm:ss').hours() : 0,
        'minute': range2.StartTime ? moment(range2.StartTime, 'HH:mm:ss').minutes() : 0,
    });

    const range2End = moment(range2.EndDate).endOf('day').set({
        'hour': range2.EndTime ? moment(range2.EndTime, 'HH:mm:ss').hours() : 23,
        'minute': range2.EndTime ? moment(range2.EndTime, 'HH:mm:ss').minutes() : 59,
    });

    if (range1Start.isSame(range2Start) && range1End.isSame(range2End)) return CollisionType.EXACT_MATCH; // exactly the same dates range

    if (range1Start.isSameOrAfter(range2Start) && range1End.isSameOrBefore(range2End)) return CollisionType.RANGE_INSIDE; // new range starts and ends within old range

    if (range2Start.isSameOrAfter(range1Start) && range2End.isSameOrBefore(range1End)) return CollisionType.RANGE_ECLIPSES; // old range starts and ends within new range

    if (range1Start.isBefore(range2Start) && range1End.isSameOrAfter(range2Start) && range1End.isBefore(range2End)) return CollisionType.START_BEFORE_END_INSIDE; // new range starts before and ends inside old range

    if (range2Start.isBefore(range1Start) && range2End.isSameOrAfter(range1Start) && range2End.isBefore(range1End)) return CollisionType.START_INSIDE_END_AFTER; // old range starts before and ends inside new range

    return CollisionType.NO_COLLISION; // no collision: [] ()
};

export const nonCollisionDaysThatExist = (range1, range2, days) => {
    let start = moment.max([moment(range1.StartDate), moment(range2.StartDate)]);
    let end = moment.min([moment(range1.EndDate), moment(range2.EndDate)]);
    const rangeDates = getDaysOfDatesRange(start, end);
    return rangeDates.filter(date => days.includes(date.toDate().getDay())).length > 0 ? getWeekDaysOfRange(start, end, days) : [];
}

export const cloneEntityWithoutSpecificFields = (entity, fieldsNotToCopy = [], fillWith) => {
    if (entity === null || entity === undefined) return entity;
    let nestedEntries = Object.entries(entity).filter(x => typeof x[1] === "object" && fieldsNotToCopy.indexOf(x[0]) === -1 && !(x[1] instanceof Date));
    return Array.isArray(entity) ?
        Object.values({
            ...entity,
            ...nestedEntries
                .reduce((accumulator, entry) => ({ ...accumulator, [entry[0]]: cloneEntityWithoutSpecificFields(entry[1], fieldsNotToCopy, fillWith) }), {})
        })
        :
        {
            ...entity,
            ...nestedEntries
                .reduce((accumulator, entry) => ({ ...accumulator, [entry[0]]: cloneEntityWithoutSpecificFields(entry[1], fieldsNotToCopy, fillWith) }), {}),
            ...fieldsNotToCopy
                .reduce((accumulator, fieldkey) => ({ ...accumulator, [fieldkey]: fillWith }), {})
        }
}
const getIntOfWeekdaysInRange = (range) => {
    return getIntWeekdays(getWeekdaysOfRangeWithDays(range.range[0], range.range[1], range.weekdays));
}

export const checkForCollisionInDateRanges = (anchor, elements, { predicate, getRange}) => {
    const anchorRange = moment.range(getRange(anchor).range);
    const anchorWeekdaysProp = getRange(anchor).weekdays;
    const anchorWeekdays = getIntWeekdays(anchorWeekdaysProp);

    return elements
        .filter(x => predicate(x))
        .filter(x => moment.range(getRange(x).range).overlaps(anchorRange, { adjacent: true })) // check if the ranges overlap
        .filter(x => (getRange(x).weekdays & anchorWeekdays) !== 0)
        .length > 0 // check if the weekdays overlap
}

export const rearangeDateRanges = (anchor, elements, { predicate, getRange, setRange, deleteElement, copyElement }, weekdaysPropName = 'Weekdays') => {
    const anchorRange = moment.range(getRange(anchor).range);
    const anchorWeekdaysProp = getRange(anchor).weekdays;
    const anchorWeekdays = getIntWeekdays(anchorWeekdaysProp);

    if (elements.length === 0
        || (anchor.IsSupplement === true && elements.length === 1 && elements[0].IsNew === true )) 
    {
        return [{ ...anchor, [weekdaysPropName]: anchorWeekdays }];
    }

    const overlappingRanges = elements
        .filter(x => predicate(x))
        .filter(x => moment.range(getRange(x).range).overlaps(anchorRange, { adjacent: true })) // check if the ranges overlap
        .filter(x => (getRange(x).weekdays & anchorWeekdays) !== 0); // check if the weekdays overlap

    const result = [{ ...anchor, [weekdaysPropName]: anchorWeekdays }, ...elements.filter(x => !overlappingRanges.includes(x))];

    overlappingRanges.forEach(x => {
        const range = moment.range(getRange(x).range);

        if (range.start.within(anchorRange) && range.end.isAfter(anchorRange.end)) // x starts inside anchor and ends after it
        {
            addToDateRangeListOnPartialRange(x, anchorWeekdays, range.start.toDate(), anchorRange.end.toDate(), copyElement, result, weekdaysPropName)

            // Shorten x start to anchor end
            setRange(x, [anchorRange.end.clone().add(1, 'd').toDate(), range.end.toDate()]);
            x[weekdaysPropName] = getIntOfWeekdaysInRange(getRange(x));
        }
        else if (range.end.within(anchorRange) && range.start.isBefore(anchorRange.start)) // x ends inside anchor and starts before it
        {
            addToDateRangeListOnPartialRange(x, anchorWeekdays, anchorRange.start.toDate(), range.end.toDate(), copyElement, result, weekdaysPropName)

            // Shorten x end to anchor start
            setRange(x, [range.start.toDate(), anchorRange.start.clone().add(-1, 'd').toDate()]);
            x[weekdaysPropName] = getIntOfWeekdaysInRange(getRange(x));
        }
        else if (range.start.within(anchorRange) && range.end.within(anchorRange)) // x is inside anchor
        {
            addToDateRangeListOnPartialRange(x, anchorWeekdays, range.start.toDate(), range.end.toDate(), copyElement, result, weekdaysPropName)

            // delete x
            deleteElement(x);
        }

        else if (anchorRange.start.within(range) && anchorRange.end.within(range)) // anchor is inside x
        {
            addToDateRangeListOnPartialRange(x, anchorWeekdays, anchorRange.start.toDate(), anchorRange.end.toDate(), copyElement, result, weekdaysPropName)

            // Split x into 2 ranges
            const newElement1 = copyElement(x, range.start.toDate(), anchorRange.start.clone().add(-1, 'd').toDate());
            newElement1[weekdaysPropName] = getIntOfWeekdaysInRange(getRange(newElement1));
            const newElement2 = copyElement(x, anchorRange.end.clone().add(1, 'd').toDate(), range.end.toDate());
            newElement2[weekdaysPropName] = getIntOfWeekdaysInRange(getRange(newElement2));

            result.push(newElement1, newElement2);
            deleteElement(x);
        }

        // Add the remaining original range to the result unless there are no weekdays left
        if (x.Weekdays !== 0){
            result.push({ ...x });
        }
    });

    result.sort((a, b) => moment(a.StartDate).toDate() < moment(b.StartDate).toDate() ? -1 : 1);
    for (let rpe of result) {
        rpe.StartDate = toServerDateFormat(rpe.StartDate);
        rpe.EndDate = toServerDateFormat(rpe.EndDate);
    }
    return result;
}

const addToDateRangeListOnPartialRange = (x, anchorWeekdays, startDate, endDate, copyElement, result, weekdaysPropName) => {
    if (anchorWeekdays !== 0 || anchorWeekdays !== 127) {
        const otherWeekdaysArr = anchorWeekdays ^ 127;
        const xWeekdays = getIntWeekdays(x[weekdaysPropName]);
        const xWeekDaysToCopy = otherWeekdaysArr & xWeekdays;

        const relevantWeekdaysToRange = getIntOfWeekdaysInRange({ range: [startDate, endDate], weekdays: xWeekDaysToCopy });
        if (relevantWeekdaysToRange) {
            const xAdditionalElement = copyElement(x, startDate, endDate);
            xAdditionalElement[weekdaysPropName] = relevantWeekdaysToRange;

            result.push(xAdditionalElement);
        }
    }
}

export const getWeekdaysOfRangeWithDays = (startDate, endDate, weekDays) => {
    const weekdaysArr = getArrWeekdays(weekDays);
    const rangeDates = getDaysOfDatesRange(startDate, endDate);
    return rangeDates.filter(date => weekdaysArr.includes(date.toDate().getDay())).length > 0 ?
        getWeekDaysOfRange(startDate, endDate, weekdaysArr) : [];
}

function uniq(array) {
    const uniqueArray = [];
    for (let i = 0; i < array.length; i++) {
        const currentElement = array[i];
        if (uniqueArray.indexOf(currentElement) === -1) {
            // If not found, add it to the uniqueArray
            uniqueArray.push(currentElement);
        }
    }
    return uniqueArray;
}

export const validateDateRange = (startDate, endDate, weekdays) => {
    if (!startDate || !endDate) return false; // Invalid date range

    const startMoment = moment(startDate).startOf("day");
    const endMoment = moment(endDate).endOf("day");

    if (!startMoment.isValid() || !endMoment.isValid()) {
        return false; // Invalid date range
    }

    if (startMoment.isAfter(endMoment)) {
        return false; // Start date is after end date
    }
    // Only check weekdays if they are provided
    if (weekdays) {
        if (weekdays.length === 0) {
            return false; // No weekdays selected
        }
        const validWeekdays = getWeekDaysOfRange(startMoment, endMoment, weekdays);
        if (validWeekdays.length !== weekdays.length) {
            return false; // Some weekdays are outside the date range
        }
    }

    return true; // Valid date range and weekdays
}

export const validateDateRangeMessage = (startDate, endDate, weekdays) => {
    if (!startDate || !endDate) return "InvalidDateRange"; // Invalid date range

    const startMoment = moment(startDate).startOf("day");
    const endMoment = moment(endDate).endOf("day");

    if (!startMoment.isValid() || !endMoment.isValid()) {
        return "InvalidDateRange"; // Invalid date range
    }

    if (startMoment.isAfter(endMoment)) {
        return "StartDateIsAfterEndDate"; // Start date is after end date
    }
    // Only check weekdays if they are provided
    if (weekdays) {
        if (weekdays.length === 0) {
            return "NoWeekDaysSelected"; // No weekdays selected
        }
        const validWeekdays = getWeekDaysOfRange(startMoment, endMoment, weekdays);
        if (validWeekdays.length !== weekdays.length) {
            return "SomeWeekdaysOutsideDateRange"; // Some weekdays are outside the date range
        }
    }
    return null; // Valid date range and weekdays
}

export const handleStartEndChange = (newDates, fromWhere, setStartDate, setEndDate) => {
    newDates[0] = newDates[0] || newDates[1];
    newDates[1] = newDates[1] || newDates[0];

    if (moment(newDates[0]).isAfter(moment(newDates[1]))) {
        setStartDate(moment(newDates[fromWhere]).format(serverDateFormat));
        setEndDate(moment(newDates[fromWhere]).format(serverDateFormat));
    }
    else {
        setStartDate(moment(newDates[0]).format(serverDateFormat));
        setEndDate(moment(newDates[1]).format(serverDateFormat));
    }
}

export const getWeekDaysOfRange = (startDate, endDate, allowedWeekDays = []) => {
    if (!startDate || !endDate) return [];
    return uniq(getDaysOfDatesRange(startDate, endDate, allowedWeekDays).map(date => date.day()))
}

export const filterDateRangesByDateRange = (datesArray, fromFilterDate, toFilterDate) => {
    const itemsInRange = datesArray.filter(x => !(moment(x.EndDate).toDate() < fromFilterDate || moment(x.StartDate).toDate() > toFilterDate));
    return filterDateRangesByWeekDays(itemsInRange, fromFilterDate, toFilterDate);
}

export const filterDateRangesByWeekDays = (datesArray, fromFilterDate, toFilterDate) => {
    const allowedWeekDays = getWeekDaysOfRange(fromFilterDate || new Date(), toFilterDate || new Date(), AllWeekDays);
    return datesArray.filter(x => !(toFilterDate && fromFilterDate) || makeIntToDaysOfWeekArray(x.Weekdays).some(d => allowedWeekDays.includes(d)));
}

export const getFilteredDates = (datesArray, filterDate) => {
    if (!filterDate) return datesArray;
    return datesArray.filter(dateRange =>
        moment(filterDate).isBetween(moment(dateRange.StartDate), moment(dateRange.EndDate))
        || [moment(dateRange.StartDate).format(dateFormat), moment(dateRange.EndDate).format(dateFormat)]
            .indexOf(moment(filterDate).format(dateFormat)) !== -1);
}

export const isNonEmptyArray = (arr) => Array.isArray(arr) && arr.length > 0

export const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

export const checkEmailValid = (emailStr) => {
    if (!emailStr) return true;
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (!emailStr.match(validRegex)) {
        return false;
    }
    return true;
}

export const currencyFormat = (currencyID) => {
    return currencyID
        ? {
            format: '%v%s',
            symbol: Currencies[currencyID]?.symbol,
            locale: document.documentElement.lang || 'he-IL'
        }
        : {
            format: '%v%s',
            symbol: '',
            locale: document.documentElement.lang || 'he-IL'
        };
};

export const formatValueAsCurrency = (value, currencyId) => {
    return formatCurrency(value, currencyFormat(currencyId))
}


export const makeIntToDaysOfWeekArray = (intValue) => {
    const result = [];

    for (let i = 0; i < 7; i++) {
        if (intValue & (1 << i)) {
            result.push(i);
        }
    }

    return result;
};

export const makeDaysOfWeekArrayIntoInt = (daysArray) => {
    let result = 0;

    for (let i = 0; i < daysArray.length; i++) {
        const dayIndex = daysArray[i];
        result |= 1 << dayIndex;
    }

    return result;
};

export const getIntWeekdays = (weekDaysValue) => {
    return Array.isArray(weekDaysValue) ? makeDaysOfWeekArrayIntoInt(weekDaysValue) : weekDaysValue;
}

export const getArrWeekdays = (weekDaysValue) => {
    return Array.isArray(weekDaysValue) ? weekDaysValue : makeIntToDaysOfWeekArray(weekDaysValue);
}

export const formatDate = (date, withDateFormat = dateFormat) => {
    const dateMoment = moment(date);
    return dateMoment.isValid() ? dateMoment.format(withDateFormat) : "";
};

export const formatDateRange = (startDate = undefined, endDate = undefined, withDateFormat = dateFormat) => {
    return `${formatDate(startDate, withDateFormat)} - ${formatDate(endDate, withDateFormat)}`;
};

export const formatMomentDateRange = (momentRange, withDateFormat = dateFormat) => {
    return `${momentRange.start.format(withDateFormat)} - ${momentRange.end.format(withDateFormat)}`
}

export const convertToDateTime = (date, time) => {
    const dateMoment = moment(date);
    if (!time) {
        return dateMoment;
    }

    const timeMoment = moment(time, timeFormat);
    dateMoment.set({
        'hour': timeMoment.hours(),
        'minute': timeMoment.minutes(),
        'second': timeMoment.seconds(),
        'millisecond': timeMoment.milliseconds()
    });
    return dateMoment;
};

export const getEntityDateTimeRange = (entity) => {
    return moment.range(
        convertToDateTime(entity.StartDate, entity.StartTime),
        convertToDateTime(entity.EndDate, entity.EndTime)
    );
};

export const convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
        var dataUrl = reader.result;
        var base64 = dataUrl.split(',')[1];
        resolve(base64);
    };
    reader.readAsDataURL(blob);
});

/**
 * Generates all combinations of given fields based on the defined constraints. If an existing combination is found,
 * it is skipped.
 * @param {Object} fields - An object where each key is a field name and its value is an object defining min and max values.
 * @param {Array} existingCombinations - An array of existing combinations to be checked against.
 * @param {Array} forbiddenCombinations - An array of forbidden combinations to be checked against.
 * @param {Function} constraintFunc - A function that takes a combination and returns a boolean indicating
 *                                    whether the combination meets the constraints or not.
 * @param {Object} [extraFields] - An optional object where each key is a field name and its value is the default value
 *                                 or a function returning a value.
 * @returns {Array} An array of all unique generated combinations.
 */
export const getCombinationsPossibilities = ({ fields, existingCombinations, constraintFunc, extraFields = {}, forbiddenCombinations = [] }) => {
    const combinations = [];

    const fieldNames = Object.keys(fields);

    // Transform existing combinations and forbidden combinations into a set for O(1) lookup times
    // Only use the field keys for comparison, not all object properties
    const existingSet = new Set(
        existingCombinations.map(combination =>
            fieldNames.map(key => `${key}:${combination[key]}`).sort().join('|'))
    );

    const forbiddenSet = new Set(
        forbiddenCombinations.map(combination =>
            Object.entries(combination).sort().map(([key, val]) => `${key}:${val}`).join('|'))
    );

    const generateCombinations = (fieldEntries, currentIdx, currentCombination) => {
        // Base case: if we have processed all fields, check if the current combination is not in the existing combinations
        if (currentIdx === fieldEntries.length) {
            const combinationKey = Object.entries(currentCombination).sort()
                .map(([key, val]) => `${key}:${val}`).join('|');

            // If the combination does not exist in the existing combinations and is not forbidden, add it to the combinations array
            if (!existingSet.has(combinationKey) && !forbiddenSet.has(combinationKey)) {
                const extraFieldsToAdd = Object.entries(extraFields).reduce((acc, [key, val]) => {
                    acc[key] = typeof val === 'function' ? val() : val;
                    return acc;
                }, {});
                combinations.push({ ...currentCombination, ...extraFieldsToAdd });
            }

            return;
        }

        // Get the field name and its constraints
        const [fieldName, fieldConstraints] = fieldEntries[currentIdx];
        const { min, max } = fieldConstraints;

        // Generate all possible values for the current field
        for (let value = min; value <= max; value++) {
            currentCombination[fieldName] = value;

            // Prepare a combination for constraint check
            const completeCombination = fieldEntries.reduce((acc, [key]) => {
                acc[key] = acc[key] || 0;
                return acc;
            }, { ...currentCombination });

            // Check if the combination meets the constraints
            if (constraintFunc(completeCombination)) {
                // If constraints are met, generate combinations for the next field
                generateCombinations(fieldEntries, currentIdx + 1, currentCombination);
            }
        }

        // Remove the field from the current combination before moving to the next value
        delete currentCombination[fieldName];
    };

    // Convert the fields object to an array of [fieldName, fieldConstraints] entries
    const fieldEntries = Object.entries(fields);

    // Start generating combinations from the first field
    generateCombinations(fieldEntries, 0, {});

    // Return the combinations array
    return combinations;
};


/**
 * Function getMissingFieldsFromObject
 * @description This function checks an object for missing keys (fields), including nested keys. A key is considered missing if it does not exist in the object or its value is `undefined`, `null`, or an empty string.
 * @param obj - The object to be checked for missing fields.
 * @param keys - An array of keys to be checked in the object. This array can include nested keys, specified using dot notation.
 * @returns - An array of keys that are missing from the object. If all keys are present and their values are not `undefined`, `null`, or an empty string, it returns an empty array.
 * @example
 * let obj = {
 *     a: "apple",
 *     b: "banana",
 *     c: {
 *         d: "dog",
 *         e: "elephant",
 *         f: null
 *     }
 * };
 *
 * let keys = ["a", "b", "c.d", "c.e", "c.f", "g"];
 * console.log(getMissingFieldsFromObject(obj, keys)); // Output: ["c.f", "g"]
 */
export function getMissingFieldsFromObject(obj, keys) {
    return keys.reduce((acc, key) => {
        const parts = key.split('.');
        const value = parts.reduce((o, k) => (o || {})[k], obj);
        if (value === undefined || value === null || value === '') {
            return [...acc, key];
        }
        return acc;
    }, []);
}


export function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

/**
 * Generates mock data based on the provided property types and options.
 *
 * @param {number} count - The number of mock items to generate.
 * @param {Object} properties - An object specifying the property names and their types.
 * @param {Object} [options] - Additional options for generating mock data.
 * @param {Object} [options.datesRange] - Options for generating date ranges.
 * @param {Date} [options.datesRange.startDate] - The start date of the date range (default: 2 years ago).
 * @param {Date} [options.datesRange.endDate] - The end date of the date range (default: current date).
 * @param {Object} [options.weekDays] - Options for generating weekdays.
 * @param {boolean} [options.weekDays.asArray=false] - Whether to return weekdays as an array (default: false).
 * @param {Function} [options.onInvalidType] - A function to handle invalid property types (default: null).
 * @returns {Array} An array of mock items.
 *
 * @example
 * const propertyTypes = {
 *   STRING: 'string',
 *   NUMBER: 'number',
 *   BOOLEAN: 'boolean',
 *   DATE: 'date',
 *   DATES_RANGE: 'datesRange',
 *   WEEK_DAYS: 'weekDays',
 * };
 *
 * const properties = {
 *   name: propertyTypes.STRING,
 *   age: propertyTypes.NUMBER,
 *   IncludeVat: propertyTypes.BOOLEAN,
 *   checkInDate: propertyTypes.DATE,
 *   fromToDates: propertyTypes.DATES_RANGE,
 *   scheduleWeekDays: propertyTypes.WEEK_DAYS,
 * };
 *
 * const options = {
 *   datesRange: {
 *     startDate: new Date(2020, 0, 1),
 *     endDate: new Date(2023, 11, 31),
 *   },
 *   weekDays: {
 *     asArray: true,
 *   },
 *   onInvalidType: (key, type) => {
 *     console.warn(`Invalid type '${type}' for property '${key}'. Using default value.`);
 *     return 'Default Value';
 *   },
 * };
 *
 * const mockData = getMockData(5, properties, options);
 * console.log(mockData);
 */
export const propertyTypesForMockData = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    DATE: 'date',
    DATES_RANGE: 'datesRange',
    WEEK_DAYS: 'weekDays',
};

export const getMockData = (count, properties, options = {}) => {
    const { datesRange: datesRangeOptions = {}, weekDays: weekDaysOptions = {}, onInvalidType = null } = options;

    const {
        startDate: datesRangeStartDate = new Date(new Date().getFullYear() - 2, 0, 1),
        endDate: datesRangeEndDate = new Date(),
    } = datesRangeOptions;

    const { asArray: weekDaysAsArray = false } = weekDaysOptions;

    // Function to generate a mock value based on the property type
    const generateMockValue = (type, key) => {
        switch (type) {
            case propertyTypesForMockData.NUMBER:
                // Generate a random number between 1 and 100
                return Math.floor(Math.random() * 100) + 1;
            case propertyTypesForMockData.STRING:
                // Generate a mock string with the property key and a random number
                return `Mock ${key} ${Math.floor(Math.random() * 1000) + 1}`;
            case propertyTypesForMockData.BOOLEAN:
                // Generate a random boolean value
                return Math.random() < 0.5;
            case propertyTypesForMockData.DATE: {
                const startDate = datesRangeStartDate;
                const endDate = datesRangeEndDate;
                // Generate a random date within the specified range
                return new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime()));
            }
            case propertyTypesForMockData.DATES_RANGE: {
                // Generate a random start date
                const startDate = generateMockValue(propertyTypesForMockData.DATE);
                const endDate = new Date(startDate);
                // Set the end date to be 1 to 10 days after the start date
                endDate.setDate(endDate.getDate() + Math.floor(Math.random() * 10) + 1);
                return [startDate, endDate];
            }
            case propertyTypesForMockData.WEEK_DAYS: {
                // Generate a random integer between 0 and 127 (inclusive)
                const randomInt = Math.floor(Math.random() * 128);
                // If weekDaysAsArray is true, convert the integer to an array of weekdays
                // Otherwise, return the integer as is
                return weekDaysAsArray ? makeIntToDaysOfWeekArray(randomInt) : randomInt;
            }
            default:
                // If the property type is invalid, call onInvalidType if provided, otherwise return null
                return onInvalidType ? onInvalidType(key, type) : null;
        }
    };

    // Generate an array of mock items
    const mockItems = Array.from({ length: count }, () => {
        const mockItem = {};
        // Iterate over each property in the properties object
        for (const [key, type] of Object.entries(properties)) {
            // Generate a mock value for each property based on its type
            mockItem[key] = generateMockValue(type, key);
        }
        return mockItem;
    });

    return mockItems;
};

/**
 * @summary Round a decimal number to a specific precision
* @param {number} num - The number to round
* @param {number} precision - The amount of digits to fix to
* @returns {number} A number fixed to the chosen precision
*/
export const roundToPrecision = (num, precision) => {
    if (num === null || typeof num === 'undefined' || typeof precision !== 'number') {
        return num;
    }
    return parseFloat(num.toFixed(precision));
}


export const isCovered = (container, elements) => {
    if (!elements || elements.length === 0) {
        return {
            hasGap: true,
            hasStartGap: true,
            hasEndGap: true,
            normalizedElements: [],
            earliestStart: moment(container.StartDate),
            latestEnd: moment(container.EndDate)
        };
    }
    const toMoment = (val) => moment.isMoment(val) ? val : moment(val);
    const startDate = toMoment(container.StartDate);
    const endDate = toMoment(container.EndDate);
    const normalizedElements = elements
        .map(el => ({
            Start: toMoment(el.StartDate),
            End: toMoment(el.EndDate)
        }))
        .filter(el =>
            el.End.isSameOrAfter(startDate) &&
            el.Start.isSameOrBefore(endDate)
        );
    const earliestStart = moment.min(normalizedElements.map(el => el.Start));
    const latestEnd = moment.max(normalizedElements.map(el => el.End));

    const hasStartGap = earliestStart.startOf("day").isAfter(startDate);
    const hasEndGap = latestEnd.endOf("day").isBefore(endDate);
    const hasGap = hasStartGap || hasEndGap;
    return {
        hasGap,
        hasStartGap,
        hasEndGap,
        normalizedElements,
        earliestStart,
        latestEnd
    }
}

/**
 * Determines if a date is a weekend day based on locale.
 * @param {string} locale - The locale code (e.g., 'he-IL', 'en-US', 'he')
 * @param {moment.Moment|Date} date - The date to check
 * @returns {boolean} True if the date is a weekend day
 */
export const isWeekendByLocale = (locale, date) => {
    // Handle both moment objects and native Date objects
    const day = typeof date.day === 'function' ? date.day() : date.getDay(); // 0 = Sunday, 1 = Monday, ..., 5 = Friday, 6 = Saturday

    // Hebrew locale uses Friday/Saturday weekend
    const isIsraelLocale = locale === Languages.Hebrew.locale || locale ===  Languages.Hebrew.code;

    if (isIsraelLocale) {
        // Israel: weekends are Friday (5) and Saturday (6)
        return day === 5 || day === 6;
    } else {
        // Western countries: weekends are Saturday (6) and Sunday (0)
        return day === 6 || day === 0;
    }
};

